// Runtime configuration service
// This service provides access to environment-specific configuration
// that is loaded at runtime instead of being baked into the build
export class RuntimeConfigService {
    constructor() {
        // Check if runtime config is available
        if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
            this.config = window.__RUNTIME_CONFIG__;
        }
        else {
            // Fallback to default values if runtime config is not available
            // This can happen during development or testing
            this.config = {
                // WS_URL: 'wss://ws-staging.alphafi.xyz/ws', //'ws://localhost:8080/ws',
                WS_URL: 'wss://ws-staging.alphafi.xyz/ws', //'ws://localhost:8083/ws',
                ALPHALEND_WS_URL: 'wss://ws-staging.alphalend.xyz/ws', //'ws://localhost:8084/ws',
                API_BASE_URL: 'http://localhost:8080',
                APR_URL: 'https://api.alphafi.xyz/apr',
                ENABLE_WEBSOCKET: true,
                DEFAULT_NETWORK: 'mainnet',
                MAINNET_RPC_URL: '',
                TESTNET_RPC_URL: '',
                DEVNET_RPC_URL: '',
                ENABLE_DEBUG_LOGS: false,
            };
        }
    }
    static getInstance() {
        if (!RuntimeConfigService.instance) {
            RuntimeConfigService.instance = new RuntimeConfigService();
        }
        return RuntimeConfigService.instance;
    }
    getConfig() {
        return this.config;
    }
    get(key) {
        return this.config[key];
    }
    // Convenience methods for common config values
    getWebSocketUrl() {
        return this.config.WS_URL;
    }
    getAlphalendWebSocketUrl() {
        return this.config.ALPHALEND_WS_URL;
    }
    getApiBaseUrl() {
        return this.config.API_BASE_URL;
    }
    isWebSocketEnabled() {
        return this.config.ENABLE_WEBSOCKET;
    }
    getDefaultNetwork() {
        return this.config.DEFAULT_NETWORK;
    }
    getRpcUrl(network) {
        switch (network) {
            case 'mainnet':
                return this.config.MAINNET_RPC_URL;
            case 'testnet':
                return this.config.TESTNET_RPC_URL;
            case 'devnet':
                return this.config.DEVNET_RPC_URL;
            default:
                return '';
        }
    }
    isDebugLogsEnabled() {
        return this.config.ENABLE_DEBUG_LOGS;
    }
    getAprUrl() {
        return this.config.APR_URL;
    }
}
// Export a singleton instance
export const runtimeConfig = RuntimeConfigService.getInstance();
